module.exports = __webpack_public_path__ + "static/media/whatsapp.3e997f05.svg";